import React, { useState, useEffect } from "react";
import api from '@api'; // Instead of ../../../utils/api
import { useNavigate, useParams } from "react-router-dom";
import "./PlayerPublic.css";
import { useDomain } from '@useDomain';

import DefaultImage from './image/default.png';
import Gatorade from './image/gatorade.png'

function PlayerPublic() {
  const [player, setPlayer] = useState(null);
  const [allTeams, setAllTeams] = useState([]);
  const [allStats, setAllStats] = useState([]);
  const { domain, slug } = useDomain(); // ✅ Centralized domain/slug
  const { id } = useParams();
  const navigate = useNavigate()

  useEffect(() => {
    const getPlayer = async () => {
      try {
        const response = await api.get(`/api/playersv2/${id}/basic`, {
          params: slug ? { slug, scope: "active" } : { domain, scope: "active" },
        });
        console.log(response.data)
        const activeSeasonId = Number(response.data.activeSeasonId || response.data.season?.id);


        let extractedTeams = response.data.teamHistory
          ?.filter(entry => entry.season?.active)
          .map(entry => ({
            id: entry.team?.id, // ✅ just the teamId for routing
            seasonId: entry.season?.id,
            label: `${entry.team?.name} (${entry.season?.name})`,
          }))
          .filter(team => team.id);


        if (extractedTeams.length === 0) {
          // fallback to latest team
          const last = response.data.teamHistory?.[0];
          if (last) {
            extractedTeams = [{
              id: last.team?.id,  // ✅ just team id
              seasonId: last.season?.id,
              label: `${last.team?.name} (${last.season?.name})`,
            }];
          }
        }



        const visibleStats = response.data.allStats
          .filter(stat => !stat.hidden)
          .sort((a, b) => a.order - b.order);

        setAllTeams(extractedTeams); // ✅ move this here
        setAllStats(visibleStats);
        setPlayer({
          ...response.data.player,
          gameStats: response.data.gameStats,
        });
      } catch (error) {
        console.error("Error fetching player:", error.response?.data || error.message);
      }
    };
    getPlayer();
  }, [id, domain]);


  const uniqueGames = Array.from(
    new Map(
      player?.gameStats?.map((gameStat) => {
        const game = gameStat.game;
        return [
          game?.id,
          {
            id: game?.id,
            date: game?.date || null,
            homeTeam: game?.home_team?.team?.name || "Unknown",
            awayTeam: game?.away_team?.team?.name || "Unknown",
            stats: allStats.map((stat) => {
              const statForThisGame = player.gameStats
                .filter((gs) => gs.game_id === game?.id)
                .find((gs) => gs.stat_id === stat.id);
              return {
                abbreviation: stat.abbreviation,
                value: statForThisGame ? statForThisGame.value : 0,
              };
            }),
          },
        ];
      })
    ).values()
  ).sort((a, b) => new Date(b.date) - new Date(a.date));



  const calculateAverage = (gameStats = [], statabbreviation) => {
    if (!Array.isArray(gameStats) || gameStats.length === 0) return "0.0";
    const gameStatMap = new Map();
    gameStats.forEach((gs) => {
      if (
        gs.stat?.abbreviation === statabbreviation &&
        !gameStatMap.has(gs.game_id)
      ) {
        gameStatMap.set(gs.game_id, gs);
      }
    });
    const totalGames = gameStatMap.size;
    const total = Array.from(gameStatMap.values()).reduce(
      (sum, gs) => sum + Number(gs.value),
      0
    );
    return totalGames > 0 ? (total / totalGames).toFixed(1) : "0.0";
  };

  const avgPTS = player?.gameStats ? calculateAverage(player.gameStats, "PTS") : "0.0";
  const avgAST = player?.gameStats ? calculateAverage(player.gameStats, "AST") : "0.0";
  const avgREB = player?.gameStats ? calculateAverage(player.gameStats, "REB") : "0.0";
  if (!player) return <p></p>;
  const numberAttr = player.attributeValues?.find(attr => attr.attribute?.attribute_name === "Number");
  const positionAttr = player.attributeValues?.find(attr => attr.attribute?.attribute_name === "Position");

  const getTotalStatValue = (abbreviation) => {
    const gameIdsInView = uniqueGames.map(g => g.id);

    const statMap = new Map();

    player?.gameStats.forEach(gs => {
      if (gs.stat?.abbreviation === abbreviation && gameIdsInView.includes(gs.game_id)) {
        const key = `${gs.game_id}-${gs.stat_id}`;
        if (!statMap.has(key)) {
          statMap.set(key, gs.value);
        }
      }
    });

    const total = Array.from(statMap.values()).reduce((sum, val) => sum + Number(val), 0);

    console.log(`Total ${abbreviation}:`, total);

    return total || 0;
  };


  const totalFTM = getTotalStatValue("FTM");
  const totalFTA = getTotalStatValue("FTA");
  const totalFTPercentage = totalFTA ? ((totalFTM / totalFTA) * 100).toFixed(1) : "0.0";

  const total3PM = getTotalStatValue("3PM");
  console.log(total3PM)
  return (
    <div className="player_public">
      {/* Player Detail Container */}
      <div className="player-details-container">
        {player.image ? (
          <img
            src={player.image}
            alt={`${player.firstName} ${player.lastName}`}
            className="player-page-image"
          />
        ) : (
          <img
            src={DefaultImage}
            alt={`${player.firstName} ${player.lastName}`}
            className="player-page-image"
          />
        )}
        <div className="player-details-information">
          <div className="player-details-team">
            {allTeams.length ? (
              <h5>
                {allTeams.map((team, index) => (
                  <span
                    key={team.id}
                    onClick={() =>
                      navigate(slug ? `/${slug}/teams/${team.id}` : `/teams/${team.id}`)
                    }
                    style={{ cursor: "pointer", textDecoration: "none", marginRight: 8 }}
                  >
                    {team.label}
                    {index < allTeams.length - 1 && ""}
                  </span>
                ))}
                {numberAttr ? ` | #${numberAttr.value}` : ""}
                {positionAttr ? ` | ${positionAttr.value}` : ""}
              </h5>
            ) : (
              <span>No team assigned</span>
            )}
          </div>

          <div className='player-details-name'>
            <h2>{player.firstName} </h2>
            <h2>{player.lastName || "\u00a0"}</h2>
          </div>
        </div>
      </div>
      <div className="players-averages-details">
        <section className="players-averages-details-left-section">
          <div className="box"></div>
          <div className="box">
            <h4>PPG</h4>
            <h4><strong>{avgPTS}</strong> </h4>
          </div>
          <div className="box">
            <h4>FT%</h4>
            <h4><strong>{totalFTPercentage}%</strong></h4>
          </div>
          <div className="box">
            <h4>3PM</h4>
            <h4><strong>{total3PM}</strong></h4>
          </div>

        </section>
        <section className="players-averages-details-right-section">
        </section>
      </div>
      <div className="player-public-links-container">
        <ul>
          <li>Profile</li>
          <li onClick={() =>
            navigate(
              slug
                ? `/${slug}/player/${player.id}/stats`
                : `/player/${player.id}/stats`
            )
          }>Stats</li>
          <li>Bio</li>
          <li>Videos</li>
        </ul>
      </div>
      {player?.id === 910 && (
        <a
          href="https://longshotcreative.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
          className="player-public-sponsors-container"
        >
          <div className="sponsor-banner-link">
            LONGSHOT
          </div>
        </a>
      )}



      {player?.id === 910 && (
        <div className="player-public-videos-container">
          <div className="player-video-scroll-wrapper">
            <iframe
              className="player-video-embed"
              src="https://www.youtube.com/embed/VU8PLSBUai4"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>


          </div>
        </div>
      )}

      <div className="player-public-stats-scroll-wrapper">
        <div className="player-public-stats-container">
          <h2 className="player-public-stats-title"></h2>
          <table className="player-public-stats-table">
            <thead>
              <tr>
                <th>Game Date</th>
                <th>Matchup</th>
                {allStats.map((stat) => (
                  <th key={stat.id}>{stat.abbreviation}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {uniqueGames.map((game, index) => (

                <tr key={index}>
                  <td>
                    {game.date
                      ? new Date(`${game.date}T00:00:00`).toLocaleDateString("en-US", {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      })
                      : "TBD"}
                  </td>
                  <td className="clickable-row" onClick={() =>
                    navigate(
                      slug
                        ? `/${slug}/games/${game.id}`
                        : `/games/${game.id}`
                    )
                  }>{game.homeTeam} vs {game.awayTeam}</td>
                  {game.stats?.map((statValue, idx) => (
                    <td key={idx}>
                      {(() => {
                        const abbreviation = allStats[idx]?.abbreviation;
                        const getStat = (code) => game.stats.find(s => s.abbreviation === code)?.value || 0;
                        if (abbreviation === 'FG%') {
                          const fgm = getStat('FGM');
                          const fga = getStat('FGA');
                          return fga ? ((fgm / fga) * 1).toFixed(3) : '0';
                        }
                        if (abbreviation === 'FT%') {
                          const ftm = getStat('FTM');
                          const fta = getStat('FTA');
                          return fta ? ((ftm / fta) * 1).toFixed(3) : '0';
                        }
                        if (abbreviation === '2P%') {
                          const twoPM = getStat('2PM');
                          const twoPA = getStat('2PA');
                          return twoPA ? ((twoPM / twoPA) * 1).toFixed(3) : '0';
                        }
                        if (abbreviation === '3P%') {
                          const threePM = getStat('3PM');
                          const threePA = getStat('3PA');
                          return threePA ? ((threePM / threePA) * 1).toFixed(3) : '0';
                        }
                        return statValue.value;
                      })()}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default PlayerPublic;
